// extracted by mini-css-extract-plugin
module.exports = {"flex":"footer-module--flex--1fpVX"};